import {useState, useEffect} from "react";
import slide1 from "assets/images/onboarding-img-1.png";
import slide2 from "assets/images/onboarding-img-2.png";
import slide3 from "assets/images/onboarding-img-3.png";

declare global {
    var intervalTimer: any;
    var timeoutTimer: any;
    var onboardingSlideIndex: number;
}

export const useOnboardingSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);
    const slides = [
        {
            src: slide1,
            title: "Search & Track",
            body: "Look-up cases and add them to your tracking list for quick and easy access."
        },
        {
            src: slide2,
            title: "Get Real-Time Alerts",
            body: "Get real-time alerts and quickly review documents."
        },
        {
            src: slide3,
            title: "Mobile & Desktop",
            body: "Receive alerts on the go or use the desktop website."
        }
    ];

    const autoSwitchInterval = 10000; // 10s

    useEffect(() => {
        globalThis.onboardingSlideIndex = 0;
        clearTimeout(globalThis.timeoutTimer);
        clearInterval(globalThis.intervalTimer);
        globalThis.intervalTimer = setInterval(switchSlide, autoSwitchInterval);
        return () => {
            globalThis.onboardingSlideIndex = 0;
            clearInterval(globalThis.intervalTimer);
            clearTimeout(globalThis.timeoutTimer);
        }
    }, []);

    const switchSlide = (index?: number) => {
        clearTimeout(globalThis.timeoutTimer);
        clearInterval(globalThis.intervalTimer);
        globalThis.intervalTimer = setInterval(switchSlide, autoSwitchInterval);

        globalThis.onboardingSlideIndex = index !== undefined 
            ? index 
            : globalThis.onboardingSlideIndex >= slides.length - 1
            ? 0
            : globalThis.onboardingSlideIndex + 1;

        setIsVisible(false);
        globalThis.timeoutTimer = setTimeout(() => {
            setCurrentIndex(globalThis.onboardingSlideIndex); 
        }, 100);
    }

    useEffect(() => {
        setIsVisible(true);
    }, [currentIndex]);

    return {
        slides,
        currentIndex,
        switchSlide,
        isVisible,
    }
}